import { AbstractPageDataProvider, PageDefaults } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { ITag } from "@/models/tag.entity";
import tagService from "@/services/mrfiktiv/services/tag.service";
import { MrfiktivTagControllerFindAllByPartnerIdParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const TagPageDataProvider = new (class extends AbstractPageDataProvider<
  ITag,
  MrfiktivTagControllerFindAllByPartnerIdParamsGen
> {
  itemsPerPage = PageDefaults.DEFAULT_PAGE_SIZES[2];

  async getPage(query: MrfiktivTagControllerFindAllByPartnerIdParamsGen): Promise<IPageViewModel<ITag>> {
    const res = await tagService.get({ ...query });

    const meta = res.meta;
    const data = (res.data || []) as ITag[];

    return { meta, data };
  }
})();
